import script from "./AttributesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributesTab.vue?vue&type=script&setup=true&lang=js"

import "./AttributesTab.vue?vue&type=style&index=0&id=3e444b2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e444b2d"]])

export default __exports__